export default "__VITE_ASSET__D$Xk$n1r__"